import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './state/store';
import moment from "moment";
import "moment/locale/id";
import './configs/i18n';
import './index.scss';
import 'semantic-ui-less/semantic.less';
import * as serviceWorker from './serviceWorker';
import Routes from "./routes";

// Sentry.init({dsn: "https://a5d1cf60335f4c4ba4582ed6fe52cea9@sentry.io/1535728"});

// Handle Locale
moment.locale('id');

const configuredStore = configureStore();

ReactDOM.render(
  <React.StrictMode>
      <Provider store={configuredStore.store}>
          <PersistGate loading={null} persistor={configuredStore.persistor}>
              <Routes />
          </PersistGate>
      </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
